import { render, staticRenderFns } from "./RoadImportPage.vue?vue&type=template&id=2f0c0285&scoped=true&"
import script from "./RoadImportPage.vue?vue&type=script&lang=js&"
export * from "./RoadImportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0c0285",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f0c0285')) {
      api.createRecord('2f0c0285', component.options)
    } else {
      api.reload('2f0c0285', component.options)
    }
    module.hot.accept("./RoadImportPage.vue?vue&type=template&id=2f0c0285&scoped=true&", function () {
      api.rerender('2f0c0285', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/views/RoadImportPage.vue"
export default component.exports